"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET = void 0;
var SET = 'messages/SET';
exports.SET = SET;